import { IContractsResponse } from '@/api/contract/type'
import { FC } from 'react'
import Letterhead from './Letterhead'

export type PageProps = {
  data?: IContractsResponse
}

const placeholder = (value?: string | null) => value?.trim() || '-----------'

const Page0: FC<PageProps> = ({ data }) => {
  const businessName = placeholder(
    data?.is_individual
      ? data.individual_info?.market_name
      : data?.legal_info?.market_name
  )

  return (
    <Letterhead showSignatures={false}>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        <h1 className="text-4xl font-bold">قرارداد پذیرندگی آپولون</h1>
        <p className="mt-8 text-xl">
          شرکت نوآوران کسب و کار آسان و{' '}
          <span className="font-bold">{businessName}</span>
        </p>
      </div>
    </Letterhead>
  )
}

export default Page0